import { Button, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

export type ExpiredLinkKind = 'password-reset' | 'invitation';

interface Props {
	kind: ExpiredLinkKind;
	loginRoute: string;
}

const EXPLANATION: Record<ExpiredLinkKind, { heading: string; body: string; action: string }> = {
	'password-reset': {
		heading: 'This password reset link no longer works',
		body: 'It was sent before we upgraded how signing in works. Start a new reset from the sign-in page - choose "Forgot your password?" and we will email you a fresh link.',
		action: 'Go to sign in',
	},
	invitation: {
		heading: 'This invitation link no longer works',
		body: 'It was sent before we upgraded how signing in works. If you already have a DealStack account you can sign in normally; if not, ask whoever invited you to send a new invitation.',
		action: 'Go to sign in',
	},
};

export const LinkExpiredNotice = ({ kind, loginRoute }: Props) => {
	const navigate = useNavigate();
	const { heading, body, action } = EXPLANATION[kind];

	return (
		<div
			className="min-h-screen flex flex-col items-center justify-center"
			data-testid={TEST_ELEMENT_IDS.LINK_EXPIRED_NOTICE}
		>
			<Text c="dark.6" fw={700} style={{ fontSize: '40px', lineHeight: '52px' }}>
				{heading}
			</Text>
			<Text size="B4Medium" c="dark.0" style={{ maxWidth: '560px', marginTop: '16px' }}>
				{body}
			</Text>
			<Button
				type="button"
				variant="primary"
				size="lg"
				style={{ marginTop: '32px', padding: '8px 16px', height: '48px' }}
				data-testid={TEST_ELEMENT_IDS.LINK_EXPIRED_CONTINUE_BUTTON}
				onClick={() => navigate(loginRoute)}
			>
				{action}
			</Button>
		</div>
	);
};
